import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
/* eslint-disable react/static-property-placement */

import * as React from 'react';
import classnames from 'classnames';
import { Analytics, AnalyticsLocationConsumer } from 'latitude-analytics';
import { Link } from '@latitude/link';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';
import './_login-form.css';

var CardTypeLinkDivider = function CardTypeLinkDivider() {
  return /*#__PURE__*/React.createElement("div", {
    className: "row mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "seperator-line col-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-2 text-center static-text"
  }, "or"), /*#__PURE__*/React.createElement("div", {
    className: "seperator-line col-5"
  }));
};

var LoginForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LoginForm, _React$Component);

  function LoginForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleKeyDown = function (event) {
      if (!_this.props.isOpen) return;

      if (event.keyCode === 27) {
        _this.props.onRequestClose();
      }
    };

    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = LoginForm.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
  };

  _proto.getSelectedCardName = function getSelectedCardName(cardId) {
    var selectedCardType = this.props.cardTypes.find(function (cardType) {
      return cardType.id === cardId;
    });
    return selectedCardType ? selectedCardType.name : null;
  }
  /*
   * Close the popup on Esc key,
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
      return /*#__PURE__*/React.createElement("div", {
        id: "nav-login-modal",
        ref: _this2.wrapperRef,
        className: classnames('login-form', _this2.props.className, _this2.props.isOpen ? 'login-form--is-open' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-card"
      }, /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledLink, {
        "data-trackid": "nav--login",
        className: "trackcustomanalytics btn-secondary",
        button: BUTTON_STYLE.SECONDARY,
        href: "https://servicecentre.latitudefinancial.com.au/login?migration=true",
        target: "_blank",
        trackEventData: {
          action: 'service-centre-link',
          location: location
        } // trackProductId={selectedProductId}

      }, "Log in"), /*#__PURE__*/React.createElement(_StyledLink2, {
        "data-trackid": "nav--register",
        className: "trackcustomanalytics btn-tertiary",
        button: BUTTON_STYLE.TERTIARY,
        href: "https://servicecentre.latitudefinancial.com.au/register",
        target: "_blank",
        trackEventData: {
          action: 'service-centre-link',
          location: location
        } // trackProductId={selectedProductId}

      }, "Register")), /*#__PURE__*/React.createElement(CardTypeLinkDivider, null), /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement("span", {
        className: "static-text"
      }, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement("a", {
        href: _this2.props.loginHref,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Log in")), "\xA0 to Legacy Online Service Centre")), /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(_StyledSpan, null, "Closing Soon"))));
    });
  };

  return LoginForm;
}(React.Component);

LoginForm.defaultProps = {
  isStickyOpen: false // eslint-disable-line react/default-props-match-prop-types

};
export default LoginForm;

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv",
  componentId: "sc-7vayq0-0"
})(["display:flex;flex-direction:horizontal;"]);

var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink",
  componentId: "sc-7vayq0-1"
})(["align-self:flex-start;width:45%;margin-right:5%;color:#ffffff;"]);

var _StyledLink2 = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "LoginForm___StyledLink2",
  componentId: "sc-7vayq0-2"
})(["align-self:flex-end;width:45%;"]);

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv2",
  componentId: "sc-7vayq0-3"
})(["text-align:center;"]);

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "LoginForm___StyledDiv3",
  componentId: "sc-7vayq0-4"
})(["text-align:center;padding:5pt 0;"]);

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "LoginForm___StyledSpan",
  componentId: "sc-7vayq0-5"
})(["background:#d6d3fa;border-radius:20px;padding:2pt 12pt;"]);